// Configuration options for eSTORIS REST api
import Qs from 'qs';
import kioskConfig from 'shared/config';
// Axios syntax (https://github.com/mzabriskie/axios)

// If SEO Friendly URLs are not turned on in your eSTORIS instance, remove the
// setting under test in config.js for LanguageSeoCode
const baseURL =
	kioskConfig.LanguageSeoCode && kioskConfig.LanguageSeoCode !== null
		? `${kioskConfig.ESTORIS_BASE_PATH}/${kioskConfig.LanguageSeoCode}/kiosk`
		: `${kioskConfig.ESTORIS_BASE_PATH}/kiosk`;
const timeout = 120000; // milliseconds
const headers = {
	Accept: 'application/json',
};

const config = {
	baseURL,
	timeout,
	headers,
	paramsSerializer: params =>
		// Use the query string (qs) library to serialize all params.
		// By default axios will serialize an arry as:
		// param[]=val1&param[]=val2&param[]=val3
		// Asp.net cannot handle this because it wants non simple types in the body and then wants
		// you to write a type converter or a model binder or whatever.
		// It does however accept:
		// param=val1&param=val2&param=val3
		// and puts it into a List.
		Qs.stringify(params, { arrayFormat: 'repeat' }),
};

export default config;
